export const FETCH_QUIZZES_START = 'FETCH_QUIZZES_START';
export const FETCH_QUIZZES_SUCCESS = 'FETCH_QUIZZES_SUCCESS';
export const FETCH_QUIZZES_ERROR = 'FETCH_QUIZZES_ERROR';
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS';

export const ANSWER_STATE_SET = 'ANSWER_STATE_SET';
export const QUIZ_FINISH = 'QUIZ_FINISH';
export const QUIZ_QUESTION_TOGGLE = 'QUIZ_QUESTION_TOGGLE';
export const QUIZ_RETRY = 'QUIZ_RETRY';

export const QUESTION_ADD = 'QUESTION_ADD';
export const QUIZ_CREATION_RESET = 'QUIZ_CREATION_RESET';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const INPUT_CHANGE = 'INPUT_CHANGE';
export const AUTH_INPUT_CHANGE = 'AUTH_INPUT_CHANGE';
export const SELECT_CHANGE = 'SELECT_CHANGE';